/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedFollowSearchProvider_user = {
    readonly favorites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"FollowButton_favoritesConnection">;
    } | null;
    readonly " $refType": "SbSharedFollowSearchProvider_user";
};
export type SbSharedFollowSearchProvider_user$data = SbSharedFollowSearchProvider_user;
export type SbSharedFollowSearchProvider_user$key = {
    readonly " $data"?: SbSharedFollowSearchProvider_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedFollowSearchProvider_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedFollowSearchProvider_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes"
        }
      ],
      "concreteType": "favoritesConnection",
      "kind": "LinkedField",
      "name": "favorites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "favoritesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Favorite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FollowButton_favoritesConnection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'd0deac136e73df1a3da13c1497127d43';
export default node;
